// extracted by mini-css-extract-plugin
export default {"root":"CartTotals_root__upIU8","total":"CartTotals_total__1wpAA"};